// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"7d3b472c","138":"f215629c","228":"2f3c4045","247":"1ac99b58","404":"19d1181e","415":"662f0486","513":"b344bf5c","678":"fcb17be7","767":"3e440dd8","787":"4da45d86","840":"d39105c7"}[chunkId] + ".chunk.js";
};